import './ProductDetail.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Picture from '@/common/components/atoms/Picture/Picture';
import getImageBySize from '@/common/helpers/getImageBySize';
import {
  ProductDetailDefaultProps,
  ProductDetailPropTypes,
} from '@/ebat/components/blocks/ScanSelfService/Product/ProductDetail/ProductDetail.proptypes';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

import ProductPrice from '../../../Common/Product/ProductPrice/ProductPrice';
import ProductDescription from '../../../Product/ProductDescription/ProductDescription';

const ProductDetail = (props) => {
  const {
    brand,
    className,
    complementaryDescription,
    discountClasses,
    discountPrice,
    image,
    invoiceUnit,
    manufacturerSku,
    name,
    publicPrice,
    range,
    saleUnit,
    salesPackaging,
    sku,
    taxRate,
  } = props;

  const { t } = useTranslation();

  /**
   * Return image alt or product name
   * @returns {string}
   */
  const getImageAlt = () => image?.alt || name;

  /**
   * Return image src or empty string
   * @returns {string}
   */
  const getImageSrc = () =>
    image?.url ? getImageBySize(image?.url, PRODUCTS_TYPES_FORMATS.MOSAIC) : '';

  return (
    <div className={cn('self-product-detail', className)}>
      <div className={cn('self-product-detail__content', 'content')}>
        <Picture
          alt={getImageAlt()}
          src={getImageSrc()}
          className="content__image"
          type="static"
        />
        <div className={cn('content__infos', 'infos')}>
          <ProductDescription
            brand={brand}
            className="product-infos__title"
            complementaryDescription={complementaryDescription}
            discountClasses={discountClasses}
            manufacturerSku={manufacturerSku}
            name={name}
            range={range}
            sku={sku}
          />

          <div className="product-infos__prices">
            {publicPrice !== undefined && publicPrice > 0 && (
              <ProductPrice
                className={cn('product__public-price', {
                  'product__public-price-discount': discountPrice,
                })}
                context="product-public-price"
                invoiceUnit={invoiceUnit}
                label={t('common:entities:product.price.public_price')}
                price={publicPrice}
                sup={false}
              />
            )}
            <ProductPrice
              className={cn('product__net-price')}
              context="product-net-price"
              discountPrice={discountPrice}
              invoiceUnit={invoiceUnit}
              label={t('common:entities:product.price.public_price_ttc')}
              price={
                publicPrice > 0 && taxRate
                  ? Math.round(publicPrice + publicPrice * (taxRate / 10000))
                  : undefined
              }
              showEmptyLabel
              sup={false}
            />
          </div>
          <div className={cn('infos__packaging', 'packaging')}>
            <span className="label">
              {t('common:entities:product.sale_unit')}
            </span>
            <span className="packaging__value">
              {`${salesPackaging} ${saleUnit}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductDetail.defaultProps = {
  ...ProductDetailDefaultProps,
};

ProductDetail.propTypes = {
  ...ProductDetailPropTypes,
};

export default ProductDetail;
